import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { paths } from "@/api/schema";

import { skuBrandKeys, stockKeys } from "./query-keys";

export type BrandImportResult =
  paths["/v1/sku/brand-import"]["post"]["responses"][200]["content"]["application/json"];

/** POST /v1/sku/brand-import — multipart `file` (spec §3.3). The page renders errors inline. */
export function useBrandImport() {
  const qc = useQueryClient();
  return useMutation({
    meta: { silentError: true },
    mutationFn: async (file: File): Promise<BrandImportResult> => {
      const { data, error } = await apiClient.POST("/v1/sku/brand-import", {
        // ponytail: openapi-typescript types the binary part as string; the serializer sends the real File.
        body: { file: file as unknown as string },
        bodySerializer: () => {
          const fd = new FormData();
          fd.append("file", file);
          return fd;
        },
      });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: skuBrandKeys.all });
      void qc.invalidateQueries({ queryKey: stockKeys.all });
    },
  });
}
